import FeedbackCreate from "components/feedback";
import useMission from "pages/missionEleven/hooks";
import { useReducer } from "react";
import { userInitialState } from "reducers/userInitState";
import { userReducer } from "reducers/userReducer";
import clearLocalStorage from "utils/clearlocalStorage";

function Feedback()
{
	const [ userState ] = useReducer(userReducer, userInitialState);
	const missionContext = useMission();

	function clearStorage()
	{
		clearLocalStorage("mission-eleven");
	}

	// eslint-disable-next-line func-style
	const nextStep = () =>
	{
		missionContext.setStep((prevState) => prevState + 1);
	};

	return (
		<FeedbackCreate nextStep={nextStep} missionNumber={11} name={userState.user?.name} clearStorage={clearStorage} />
	);
}

export default Feedback;
